const platformList = [
  { img: "/imgs/live/platform/router.png", platform: "路由器" },
  { img: "/imgs/live/platform/windows.png", platform: "Windows" },
  { img: "/imgs/live/platform/mac.png", platform: "Mac" },
  { img: "/imgs/live/platform/android.png", platform: "安卓手机" },
  { img: "/imgs/live/platform/ios.png", platform: "苹果手机" },
  { img: "/imgs/live/platform/sdk.png", platform: "SDK接入" },
];
export const Platform = () => {
  return (
    <div className="flex justify-center bg-gradient-to-b from-[#FFF] via-[#F8F6FF] via-[#E8F3FF] to-[#FFF]">
      <div className="w-[1920px] pt-[41px] px-[15rem] pb-[52px]">
        <div className="text-[#333] text-center font-['Alibaba_PuHuiTi_3.0'] text-[45px] font-bold leading-[120%] tracking-[4.5px]">
          全平台支持
        </div>
        <div className="text-[#333] text-center mt-[24px] font-['Alibaba_PuHuiTi_3.0'] text-[20px] font-normal ">
          光年全球直播专线支持多终端设备，可快速部署，让企业享受各个国家地区的直播网络
        </div>
        <div className="flex mt-[56px] h-[160px] justify-between">
          {platformList.map((item) => (
            <Item key={item.platform} title={item.platform} img={item.img} />
          ))}

          <img
            src="/imgs/live/platform/software.png"
            className="aspect-[300/160] w-[300px] h-[160px]"
          />
        </div>
        <div className="text-[#333] font-['Alibaba_PuHuiTi_3.0'] text-[20px] font-normal mt-[60px] text-center">
          直播专线仅支持海外直播平台、合规运营推广场景使用，不支持违规翻墙
        </div>
      </div>
    </div>
  );
};

const Item = (props: { title: string; img: string }) => {
  return (
    <div className="flex min-w-[160px] h-[160px] flex-col justify-center items-center flex-shrink-0">
      <img src={props.img} className="aspect-[160/160] w-[160px] h-[160px]" />
    </div>
  );
};
